import classNames from 'clsx';
import React from 'react';

import CheckGreen from '../../../../../../assets/icons/check-green.svg';
import CloseIcon from '../../../../../../assets/icons/close-red.svg';
import { CardType } from '../../../../../../types/cardType';

import { container, documentsIcon } from './DocumentRequirements.scss';
import DocumentsGroup from './DocumentsGroup/DocumentsGroup';
import { defaultMessages, translationMap } from './utils/translationUtils';

interface Props {
  className?: string;
  type: number;
  i18nSystemName: string;
}

const DocumentRequirements: React.FC<Props> = ({ className, type, i18nSystemName }) => {
  const { acceptedDocuments, requiredDocuments } = translationMap[type] || defaultMessages;
  const hasMaskIcon = [
    CardType.Visa,
    CardType.MasterCard,
    CardType.Solo,
    CardType.MuchBetter
  ].includes(type);

  return (
    <div className={classNames(container, className)}>
      <DocumentsGroup
        title={acceptedDocuments.title}
        options={acceptedDocuments.options}
        i18nSystemName={i18nSystemName}
        icon={<CheckGreen className={documentsIcon} />}
        cardHidingIcon={hasMaskIcon}
        iconIndex={type === CardType.MuchBetter ? 1 : 0}
      />
      <DocumentsGroup
        title={requiredDocuments.title}
        options={requiredDocuments.options}
        i18nSystemName={i18nSystemName}
        icon={<CloseIcon className={documentsIcon} />}
      />
    </div>
  );
};

DocumentRequirements.displayName = 'DocumentRequirements';

export default DocumentRequirements;
